import React, {useContext, useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';

import {Container, Grid, LinearProgress} from '@mui/material';
import {PageHeader} from '../../common';
import {FetchContext, NavContext} from '../../contexts';
import {UtenteContext, UtenteProvider} from './UtenteContext';

import {UtenteDetails} from './components/UtenteDetails';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack
    } = useContext(NavContext);

    const {
        isLoadingUtente,
        getUtenteAsync,

        isUpdatingUtente,
        updateUtenteAsync,

        isAddingUtente,
        addUtenteAsync,

        isLoadingRuoli,
        getRuoliAsync,

        isLoadingTipi,
        getTipiAsync,

        setState,
        state,
    } = useContext(UtenteContext)

    const {
        utente,
    } = state;

    const {
        utenteId,
    } = useParams();

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const utenteDetailsActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (utenteId) {
                    if (window.confirm("Confermare la modifica?")) {
                        await updateUtenteAsync(utenteId, data);
                    }
                } else {
                    if (window.confirm("Confermare l'inserimento?")) {
                        await addUtenteAsync(data);
                        goBack();
                    }
                }
                break;
            default:
                break;
        }
    }

    const [isDisabled, setIsDisabled] = useState(false);
    useEffect(() => {
        setIsDisabled(isLoadingUtente || isUpdatingUtente || isAddingUtente || isLoadingRuoli);
    }, [isLoadingUtente, isUpdatingUtente, isAddingUtente, isLoadingRuoli])

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading();
    }, [])

    useEffect(() => {
        if (user && utente)
            addBreadcrumbToken(utente.nome);
    }, [utente, user]);

    useEffect(() => {
        if (user) {
            if (utenteId) {
                getUtenteAsync(utenteId);
            } else {
                addBreadcrumbToken("Aggiungi Utente");
            }
            getRuoliAsync(0, 1000);
            getTipiAsync(0, 1000);
        }
    }, [utenteId, user]);

    return (
        <>
            <Container>
                {isLoading && <LinearProgress/>}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            save
                            onSaveClick={saveClickHandler}
                            disabled={isLoading}
                            title="Utente"
                            subtitle="Gestisci l'utente"/>
                    </Grid>
                    <Grid item xs={12}>
                        <UtenteDetails
                            disabled={isLoading}
                            formRef={formRef}
                            onActionClick={utenteDetailsActionClickHandler}/>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const UtentePage = () => {

    return (
        <UtenteProvider>
            <PageContent/>
        </UtenteProvider>
    );
}